
const userLogin = () => import('../views/Login/UserLogin.vue')
const EnterpriseLogin = () => import('../views/Login/EnterpriseLogin.vue')
const AdminLogin = () => import('../views/Login/AdminLogin.vue')
export default [
  { path: '/userLogin', name:'userLogin',component: userLogin ,meta: { title: '订单雨-用户登录'}},
  { path: '/enterpriseLogin',name:'enterpriseLogin', component: EnterpriseLogin,meta: { title: '订单雨-企业用户登录'}},
  { path: '/adminLogin',name:'adminLogin', component: AdminLogin,meta: { title: '订单雨-管理员登录'}},
]
